import { h, Fragment, render } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import Programming from './components/Programming';
import Calculations from './components/Calculations';
import Tabs from './components/Tabs';
import Depends from './components/Depends';

const $el = document.getElementById('pricing-table');

const PricingTable = () => {
  const [servicesList, setServicesList] = useState([]);
  const [activeService, setActiveService] = useState(45);
  const [isTableRender, setIsTableRender] = useState(true);

  useEffect(() => {
    window.addEventListener('load', () => {
      const tableConfig = JSON.parse(document.querySelector('[data-services]')?.dataset.services);
      if (tableConfig) {
        setServicesList(Object.values(tableConfig).filter((service, index) => {
          if (service.isEnabled) {
            return service;
          }
        }).filter((service, index) => {
          if (index === 0) {
            setActiveService(service.id)
          }
          return service;
        }));
        setIsTableRender(Object.values(tableConfig).some(s => s.isEnabled === true));
      }
    })

  }, [])
  const stemTableText = (
    <div className="table-text">
      <p>
        All prices are presented in USD and do not include VAT.
      </p>
    </div>
  );

  function renderTableText () {
    switch (activeService) {
      case 45:
      case 46:
        return stemTableText;
    }
  }

  function renderActiveServiceTable() {
    switch (activeService) {
      case 45:
        return <Calculations />
      case 46:
        return <Programming />
    }
  }

  return (
    <Fragment>
      {isTableRender && (
        <Fragment>
          <Depends />
          <div className="table-inner">
            <Tabs
              activeService={activeService}
              setActiveService={setActiveService}
              services={servicesList}
            />
            <div className="table-body">
              {renderActiveServiceTable()}
            </div>
          </div>
          {renderTableText()}
        </Fragment>
      )}
    </Fragment>
  );
};

if ($el) {
  render(<PricingTable/>, $el);
}

